import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
// @ts-expect-error Untyped import
import { selectDashboards } from '../selectors/dashboardsSelector';
export const useDashboardsMap = () => {
  const dashboards = useSelector(selectDashboards);
  const dashboardsMap = useMemo(() => {
    if (!dashboards) {
      return ImmutableMap();
    }
    return ImmutableMap(dashboards.map(dashboard => [dashboard.get('id'), dashboard]));
  }, [dashboards]);
  return dashboardsMap;
};